import { render, staticRenderFns } from "./labList.vue?vue&type=template&id=2fd6d0f4&scoped=true"
import script from "./labList.vue?vue&type=script&lang=js"
export * from "./labList.vue?vue&type=script&lang=js"
import style0 from "./labList.vue?vue&type=style&index=0&id=2fd6d0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd6d0f4",
  null
  
)

export default component.exports